import lowerCase from 'lodash/lowerCase';
import toString from 'lodash/toString';
import trim from 'lodash/trim';
import { pipe } from './pipe';

export const stringForCompare = pipe(toString, trim, lowerCase);
